import { createAsyncThunk } from '@/redux/createAsyncThunk';
import { getAuthToken } from '@/redux/modules/account/user/user.selectors';
import { getDeployment } from '@/redux/modules/config';
import { getLotsBySellerId } from '@/redux/modules/storefront/storefront.api';
import { StoreFrontData } from '@/redux/modules/storefront/storefront.types';

export const fetchStorefrontItems = createAsyncThunk<StoreFrontData, number>(
    'la/ui/storefront/fetchStorefrontItems',
    async (sellerId, { getState }) => {
        const state = getState();
        const deployment = getDeployment(state);
        const authToken = getAuthToken(state);

        const { data } = await getLotsBySellerId({
            authToken,
            deployment,
            sellerId,
        });

        return data;
    }
);
